import React from 'react'

export default function Dmwf2025() {
  return (
    <div>
       <div class="service_area pb-70">
       
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mb-3 mb-md-0">
            <div class="service_style_two mb-4">
              <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/dmwf-summit.jpg' className="img-fluid" alt="Winter Data Summit"/>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
                <div class="service_style_two_title pb-3 mr-90">
                  <h4>DMWF Europe - Amsterdam 2025.  </h4>
                </div>
                <div class="service_style_two_text">
                  <p className='text-left ml-80'>
                  Date - 25 - 26 Nov 2025  <br/> Venue - Rai, Amsterdam
                  </p>
                  <div class="button three past-event mr-300">
                <a href="/dmwf-event">Know More</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
